export function compareStringIgnoreCase(word1: string, word2: string) {
  return word1.toLowerCase() === word2.toLowerCase();
}